export default "<markdown fxFlexFill [data]=\"questionMeta.text\" ></markdown>\n";